<template>
    <div class="d-inline-block" v-if="options">
        <div :class="{ disabled: showDisabled }" class="badge badge-light active-filter mr-2 mt-2" v-for="(option, index) in options" @mouseover="hoverState = index" @mouseleave="hoverState = false">
            <i class="fa-icon" :class="faIcon"></i> {{option.label}}

            <div class="badge badge-sm badge-light hoverState" @click="removeOption(option, index)" v-if="hoverState === index">
                <i class="fas fa-times"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {

        },
        props: {
            value: {
                type: Object|Array
            },
            placeholder: {
                type: String,
                default: ''
            },
            faIcon: {
                type: String,
                default: ''
            },
			showDisabled: {
				type: Boolean,
				default: false
			}
        },
        data() {
            return {
                options: null,
                hoverState: false
            }
        },
        watch: {
            value(value) {
                this.options = value;
            }
        },
        beforeDestroy() {
        },
        mounted() {
        },
        computed: {
        },
        methods: {
            removeOption(option) {
                this.hoverState = false;

                for(let index in this.options) {
                    if(!this.options.hasOwnProperty(index)) {
                        continue;
                    }
                    if(this.options[index].value === option.value) {
                        this.options.splice(index, 1);
                        break;
                    }
                }
                this.$emit('input', this.options);
            }
        }
    }
</script>

<style lang="scss">
    @import "../../../sass/variables";

    .overflow-scroll {
        max-height: 400px;
        overflow-y: scroll;
    }

    .active-filter {
        position: relative;
    }

    .active-filter .hoverState {
        width: 100%;
        height: 100%;
        display: block;
        background: $primary;
        color: white;
        font-weight: bold;
        text-align: center;
        position: absolute;
        top: 0;
        left: 0;
        font-size: 15px;
        padding: 6px;
        cursor: pointer;
    }

    .active-filter .fa-icon {
        font-size: 11px;
        margin-right: 3px;
        color: $primary;
    }

	.active-filter.disabled, .active-filter.disabled .fa-icon {
		color: #d1d8de;
		background: #e9ecef;
		text-decoration: line-through;
	}
</style>